import { AxiosResponse } from 'axios';
import querystring from 'querystring';
import { getStoreProxyUrl } from '..';
import { createPayload, postProxy } from '../utilis';

interface CallConfig<P> {
    dbUrl: string;
    endpoint: string;
    payload: P;
}

/**
 * ###Deprecated###!!! Makes an API call to the given endpoint with the given payload.
 */
export const makeApiCall = async <T, P>({
    dbUrl,
    payload,
    endpoint,
}: CallConfig<P>): Promise<AxiosResponse<T>> => {
    // console.log({ dbUrl, payload, endpoint });
    const data = querystring.stringify({
        ...createPayload(payload),
        webservice: endpoint,
    });
    return postProxy<T>(getStoreProxyUrl(), data);
};

interface NewCallConfig {
    dbUrl: string;
    endpoint: string;
    requestParams: any;
}

export const newMakeApiCall = async <T>({
    dbUrl,
    requestParams,
    endpoint,
}: NewCallConfig): Promise<AxiosResponse<T>> => {
    const requestParamsStr = querystring.stringify({
        ...createPayload(requestParams),
        webservice: endpoint,
    });
    // console.log(req);
    // req.then((json) => console.log(json));
    return postProxy<T>(getStoreProxyUrl(), requestParamsStr);
};
